import type { TrackDataUnion } from "common-types";
import type { Tracker } from "./trackers/Tracker";

declare let window: Window & {
  fandomTrack: { q: TrackDataUnion[] };
};

export class Tracking {
  constructor(private readonly trackers: Tracker[]) {
    const currentStack = window.fandomTrack.q;
    window.fandomTrack.q.push = (...args: TrackDataUnion[]): number => {
      args.forEach((arg) => this.executeTracking(arg));
      return 0;
    };
    currentStack.forEach((cmd) => this.executeTracking(<TrackDataUnion>cmd));
  }

  private executeTracking(trackData: TrackDataUnion): void {
    this.trackers.forEach((tracker) => tracker.trackEvent(trackData));
  }
}
